// The relay URL is baked into the build via VITE_API_BASE_URL - there's no
// Settings screen to configure it at runtime.
export function getApiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL;
  if (configured) return configured.replace(/\/$/, "");
  if (import.meta.env.DEV) return "http://localhost:8000";
  // Missing VITE_API_BASE_URL in a prod/staging build is a misconfiguration.
  // Fail loudly instead of silently pointing at localhost, which would look
  // fine until someone tried to upload or download.
  // eslint-disable-next-line no-console
  console.error("VITE_API_BASE_URL is not set for this build - relay uploads/downloads will fail.");
  return "";
}
